export interface PossibleTypesResultData {
    possibleTypes: {
        [key: string]: string[];
    };
}
const result: PossibleTypesResultData = {
    possibleTypes: {
        Bookmarkable: ['Category', 'Company', 'FeedPost'],
        Followable: ['Company', 'User'],
        Participant: ['Company', 'User'],
        ReactionTarget: ['FeedComment', 'FeedPost'],
    },
};
export default result;
